// extracted by mini-css-extract-plugin
export default {"main":"style_main__Si7OT","store-btn-wrapper":"style_store-btn-wrapper__WPoE7"};